import { MapsAPILoader } from '@agm/core';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ImportDataService } from 'libs/features/src/lib/layout/my-organization/import-project-components/import-data.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';

@Component({
  selector: 'piqet-angular-test-automation',
  templateUrl: './test-automation.component.html',
  styleUrls: ['./test-automation.component.scss'],
})
export class TestAutomationComponent {
  modalLabel: any;
  isShowChange = false;
  selectedFiles: any;
  imageUrl: any;
  fileBase64: any;
  testAutomationForm!: FormGroup;
  submitted = false;
  triggerList: any;
  disableSubmit = true;
  @Output() testAutomation = new EventEmitter<any>();
  automationData: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    private spinnerService: NgxSpinnerService,
    private sharedService: SharedService,
    private mapsAPILoader: MapsAPILoader,
    private importProjectDataService: ImportDataService,
    private projectService: ProjectsService,
    private http: HttpClient,
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private administratorService: AdministratorService,
    private cookieService: CookieService
  ) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.automationData = this.modal?.modalService?.config?.initialState?.['automationData'];
    this.triggerList = this.automationData?.triggerList;
  }

  async ngOnInit(): Promise<void> {
    this.testAutomationForm = this.formBuilder.group({
      email: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/),
        ],
      ],
    });
  }

  onSave(): void {
    if (this.testAutomationForm.valid) {
      const data = {
        userEmail: this.testAutomationForm.get('email')?.value || null,
      };
      this.testAutomation.emit(data);
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }
}
